import { api } from 'services/api/baseBackendAPI';

export const portfolioTeamApi = api.injectEndpoints({
  endpoints: (build) => ({
    /**
     * Legacy: fetchPortfolioTeamDetails
     * Fetches details for portfolio team members via POST
     */
    getPortfolioTeamDetails: build.query({
      query: (requestObject) => ({
        url: `funds/getPortfolioTeams`,
        method: 'POST',
        data: requestObject,
      }),
      providesTags: (result, error, arg) => [
        { type: 'PortfolioTeam', id: arg.fund_id },
        { type: 'PortfolioTeam', id: 'LIST' },
      ],
      transformResponse: (response) => {
        return response?.data ?? [];
      },
    }),

    /**
     * Used by PeerFundPortfolioTeamModal
     * Finds other funds associated with a specific person
     */
    getPeerFundsForPerson: build.query({
      query: (params) => ({
        url: `funds/getPeerFundForPerson`,
        method: 'GET',
        params,
      }),
      transformResponse: (response) => response.data,
      providesTags: (result, error, params) => [
        {
          type: 'PortfolioTeam',
          id: `fund_id${params.fund_id} person_id${params.person_id}`,
        },
      ],
    }),

    upsertPortfolioTeam: build.mutation({
      query: (payload) => ({
        url: `funds/upsertPortfolioTeam`,
        method: 'POST',
        data: payload,
      }),
      invalidatesTags: ['PortfolioTeam'],
    }),
  }),
  overrideExisting: true,
});

export const {
  useGetPortfolioTeamDetailsQuery, // Hook for fetching team details
  useGetPeerFundsForPersonQuery, // Hook for the modal search
  useUpsertPortfolioTeamMutation,
} = portfolioTeamApi;
